<template>
  <div>
    <md-card class="card-container">
      <div class="md-layout md-gutter">
        <div class="md-layout-item">
          <page-title :title="'匯出工作成果'"></page-title>
        </div>
      </div>
      <div class="md-layout md-gutter">
          <div class="md-layout-item">
            <md-field>
              <label>選項</label>
              <md-select v-model="data.mode">
                <md-option v-if="hasScope('RECORD_OVERVIEW_ALL')" :value="'all'">匯出全部</md-option>
                <md-option v-if="hasScope('RECORD_OVERVIEW_PERSONAL')" :value="'personal'">匯出個人</md-option>
              </md-select>
            </md-field>
          </div>
          <div class="md-layout-item">
            <md-datepicker v-model="data.created_at_from">
              <label>日期(開始)</label>
            </md-datepicker>
          </div>
          <div class="md-layout-item">
            <md-datepicker v-model="data.created_at_until">
              <label>日期(結束)</label>
            </md-datepicker>
          </div>
      </div>
      <div class="md-layout md-gutter">
        <div class="md-layout-item">
          <md-button class="float-right md-raised md-primary" @click="getWorkResult()">下載</md-button>
        </div>
      </div>
    </md-card>
  </div>
</template>

<script>
import PageTitle from '@/components/Shared/PageTitle'
import axios from 'axios'
import urls from '@/urls'
import { hasScope } from '@/services/auth'
import moment from 'moment'

export default {
  data () {
    return {
      data: {
        mode: null,
        created_at_from: null,
        created_at_until: null
      }
    }
  },
  components: {
    PageTitle
  },
  methods: {
    hasScope,
    getWorkResult: function () {
      axios({
        method: 'get',
        params: {
          ...this.data,
          created_at_from: this.data.created_at_from ? moment(this.data.created_at_from).subtract(7, 'hours') : null,
          created_at_until: this.data.created_at_until ? moment(this.data.created_at_until).add(1, 'day').hours(9) : null
        },
        url: urls({route: `record/overview`}),
        responseType: 'blob'
      }).then(function (resp) {
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(resp.data)
        link.download = '匯出工作成果.xlsx'
        link.target = '_blank'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      })
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/RecordOverview/RecordOverview.vue